export const STATUS_CODES = {
  HTTP_OK: 200,
  HTTP_ERROR_RESTRICTED_USER_ACCESS: 403,
  HTTP_ERROR_UNAUTHORIZED_USER: 401,
  HTTP_ERROR_INVALID_REQUEST: 400,
  HTTP_ERROR_NOT_FOUND: 404,
  HTTP_INTERNAL_SERVER_ERROR:500,
};

